import { Button, Input } from '@cokitchen/cokitchen-components';
import React, { useEffect } from 'react';
import './styles.scss';
import { useNavigate } from 'react-router-dom';
import useDashboardContext from 'contexts/dashboard.context';
import useKitchenInventoryStockContext, {
  IKitchenRequest
} from 'contexts/kitchen/inventory-stock.context/context';
import { DefaultKitchenRequest } from 'contexts/kitchen/inventory-stock.context/provider';

import IngredientSelct from 'components/form-comps/ingredients-select';
import useRoleContext from 'contexts/role.context';
import { InventoryModule, RolePermission } from 'models/permission.model';

const isKeyOfRequest = (key: string): key is keyof IKitchenRequest => {
  return ['id', 'name', 'measurement', 'quantity'].includes(key);
};

// const getDefRequest = (): IRequest => {
//   return {
//     id: '',
//     name: '',
//     quantity: '0',
//     vendor: {
//       id: '',
//       name: '',
//       price: ''
//     },
//     measurement: weightMeasurement[0].value
//   };
// };

interface IRequestFormFields {
  request: IKitchenRequest;
  setRequest: (request: IKitchenRequest) => void;
  handleDelete: () => void;
  className: string;
}

const RequestFormFields = (props: IRequestFormFields) => {
  const { request, setRequest, className } = props;

  const handleChange = (e: { target: { name: string; value: string } }) => {
    const { target } = e;
    const { name, value } = target;
    if (!isKeyOfRequest(name)) return;

    setRequest({
      ...request,
      [name]: value
    });
  };

  return (
    <div className={`pt-6 ${className}`}>
      <div className='px-7 form'>
        <div className='grid grid-cols-2 gap-6 mb-6'>
          <div>
            <p className='font-medium mb-2'>Item name</p>
            <IngredientSelct
              value={request?.name}
              setValue={(item) => {
                setRequest({
                  ...request,
                  name: item.name,
                  id: item.id,
                  measurement: item.unit_type
                });
              }}
            />
          </div>
          <div className='w-full md:w-[250px] flex gap-2 relative'>
            <Input
              type='tel'
              label='Quantity'
              name='quantity'
              className='w-full'
              placeholder='00'
              value={request.quantity}
              onChange={handleChange}
              inputClass='!border-b-[2px] !border-b-[#D5D6D7] bg-[#F4F5F5] !rounded-none h-[44px]'
            />
            <div className='absolute w-[50px] h-[20px] z-10 rounded-[2px] shadow bottom-[20%] right-[5%]'>
              <div className='h-5 p-1 text-[11px] flex justify-between items-center gap-[2px] cursor-pointer measurement_dropdown'>
                <span className='text-[#6F7376] truncate'>{request.measurement}</span>
                {/* <ArrowDownIcon className='w-5 h-5 text-[#96999C]' /> */}
              </div>
              {/* <Dropdown
                content={
                  <div className='h-5 p-1 text-[11px] flex justify-between items-center gap-[2px] cursor-pointer measurement_dropdown'>
                    <span className='text-[#6F7376] truncate'>{measurement}</span>
                    <ArrowDownIcon className='w-5 h-5 text-[#96999C]' />
                  </div>
                }>
                <DropdownList>
                  {weightMeasurement.map((item) => (
                    <DropdownItem
                      key={item.value}
                      onClick={() => {
                        setMeasurement(item.name);
                        setRequest({
                          ...request,
                          measurement: item.value
                        });
                      }}>
                      {item.name}
                    </DropdownItem>
                  ))}
                </DropdownList>
              </Dropdown> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const KitchenInventoryRequest = () => {
  const router = useNavigate();
  const { requests, setRequests, scrollIndex, setScrollIndex, stocksToEdit } =
    useKitchenInventoryStockContext();
  const { setIsBackLink, setBackLinkTitle } = useDashboardContext();
  const { can } = useRoleContext();
  const canWriteInventoryManagement = can(
    InventoryModule.InventoryManagement,
    RolePermission.Write
  );

  useEffect(() => {
    requests.length == 0 &&
      setRequests(
        stocksToEdit.map((stockToEdit) => ({
          id: stockToEdit.ingredient_id,
          name: stockToEdit.ingredient.name,
          measurement: stockToEdit.ingredient.unit_type || 'Kilogram',
          quantity: ''
        }))
      );
  }, []);

  useEffect(() => {
    setIsBackLink(true);
    setBackLinkTitle('Return to stock');
    return () => {
      setIsBackLink(false);
      setBackLinkTitle('');
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (scrollIndex !== null) {
        const requestElements = document.getElementsByClassName(
          `request-form-fields${scrollIndex}`
        );

        if (requestElements.length > 0) {
          requestElements[0].scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
          });
        }
      }
    }, 1000);
    return () => {
      setScrollIndex(null);
    };
  }, [scrollIndex]);

  function isStepEmpty(data: any): boolean {
    for (const item of data) {
      for (const key in item) {
        if (typeof item[key] === 'string' && item[key] === '') {
          return true;
        }
      }
    }
    return false;
  }

  return (
    <div className='ml-2 md:ml-8 request'>
      <h4 className='text-[24px] font-semibold text-[#2E3031]'>Make a request</h4>
      <p className='text-[#6F7376] text-sm mb-8'>
        Inventory running low on selected items? prepare your list
      </p>
      <div className='bg-[#F7F7F8] w-full max-w-[678px] h-auto p-1 flex  justify-center items-center'>
        <div className='bg-white w-full maxw-[670px] h-auto rounded-md  pt-6'>
          <h4 className='font-semibold text-[20px] pl-7'>Make your selections</h4>
          <div>
            {requests.map((item, index) => (
              <RequestFormFields
                request={item}
                className={`request-form-fields${index}`}
                key={index}
                setRequest={(newRequest) => {
                  setRequests(
                    requests.map((req, i) => {
                      if (i === index) return newRequest;
                      return req;
                    })
                  );
                }}
                handleDelete={() => {
                  setRequests(requests.filter((_, i) => i !== index));
                }}
              />
            ))}
          </div>
          {requests.length === 0 && (
            <div>
              <h4
                className='ml-7 my-4 text-sm
              '>
                Select items on the stock list to make request
              </h4>
            </div>
          )}
          {canWriteInventoryManagement && (
            <button
              onClick={() => setRequests([...requests, DefaultKitchenRequest])}
              className='text-[#0080E5] mt-2 font-medium text-sm ml-7 my-4'>
              + Add Item
            </button>
          )}
          {/* <div
            className='text-[#0080E5] flex items-center gap-[2px] text-sm font-medium cursor-pointer ml-7 my-4'
            onClick={() => setRequests([...requests, getDefRequest()])}>
            <AddIcon className='w-5 h-5' />
            <span>Add item</span>
          </div> */}
          <div className='flex justify-end gap-6 py-7 px-4 md:px-7 items-center border-t-2 border-t-[#F7F7F8]'>
            <Button variant='link' color='gray' small onClick={() => router(-1)}>
              Cancel
            </Button>
            {canWriteInventoryManagement && (
              <Button
                variant='block'
                color='primary'
                small
                className='w-[153px]'
                onClick={() => router('preview')}
                disabled={isStepEmpty(requests)}>
                Continue
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default KitchenInventoryRequest;
